import React, { useState } from 'react';
import styles from './account-manager-info.module.scss';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import { AccountManagerPersonModal } from '../../../unit-types-list/components/assign-accountManager-modal/assign-accountManager-modal.component';

export interface AccountManagerInfoProps {
  data: {
    accountManagerName: string;
    accountManagerId: string;
    accountManagerEmail: string;
    accountManagerPhone: string;
    propertyId: string;
  };
  eventHandlers: {
    addAccountManager: (data: Partial<UnitTypeUiModel>) => void;
    deleteAccountManager: () => void;
  };
}
export const AccountManagerInfo: React.FC<AccountManagerInfoProps> = ({ data, eventHandlers }) => {
  const isMobileView = useWindowResizer();
  const [showAccountManagerUserModal, setShowAccountManagerUserModal] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  return (
    <>
      <div className={styles['account-manager-info-container']}>
        {data?.accountManagerId ? (
          <>
            <div className={styles['account-manager-info-container-title']}>
              Account Manager Info
            </div>
            <div className={styles['account-manager-info-container-content']}>
              <div className={styles['account-manager-info-container-content-info']}>
                <label>Name :</label> <p>{data?.accountManagerName}</p>
              </div>
              <div className={styles['account-manager-info-container-content-info']}>
                <label>Email :</label> <p>{data?.accountManagerEmail}</p>
              </div>
              <div className={styles['account-manager-info-container-content-info']}>
                <label>Phone :</label> <p>{data?.accountManagerPhone}</p>
              </div>
              <div className={styles['account-manager-info-container-content-info']} />
            </div>

            <div className={styles['account-manager-info-container-actions']}>
              <Button
                onClick={() => setShowAccountManagerUserModal(true)}
                tracking={{
                  action: 'cancel',
                  category: '',
                  label: ''
                }}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
                disabled={data.propertyId === ''}
              >
                {' '}
                Update Account Manager
              </Button>

              <Button
                onClick={() => {
                  setShowDeleteModal(true);
                }}
                tracking={{
                  action: 'open',
                  category: 'blocked-date',
                  label: 'add-blocked-date-modal'
                }}
                type={ButtonType.primaryInverted}
                size={ButtonSize.medium}
              >
                Delete Account Manager
              </Button>
            </div>
          </>
        ) : (
          <div>
            <img
              src={`${PUBLIC_PATH}/assets/jpeg/add-guest.jpeg`}
              alt="assign accountManager"
              className={styles['account-manager-info-container-content-image']}
            />

            <Button
              onClick={() => {
                setShowAccountManagerUserModal(true);
                trackEvent('add', {
                  category: '',
                  label: ''
                });
              }}
              tracking={{
                action: 'cancel',
                category: '',
                label: ''
              }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              disabled={data?.propertyId === ''}
            >
              {' '}
              Assign Account Manager
            </Button>
            {data?.propertyId === '' && (
              <span className={styles['account-manager-info-container-content--hint']}>
                you can't assign a Account Manager to a unit that doesn't have property
              </span>
            )}
          </div>
        )}

        <ConfirmModal
          config={{ showModal: showConfirmModal, message: '' }}
          eventHandlers={{
            denyAction: () => {
              setShowConfirmModal(false);
              setShowAccountManagerUserModal(false);
            },
            confirmAction: () => {
              setShowConfirmModal(false);
              setShowAccountManagerUserModal(false);
              trackEvent('add', {
                category: '',
                label: ''
              });
            }
          }}
        />

        <ConfirmModal
          config={{
            showModal: showDeleteModal,
            message: 'Are you sure you want to delete this Account Manager?'
          }}
          eventHandlers={{
            denyAction: () => {
              setShowDeleteModal(false);
              setShowAccountManagerUserModal(false);
            },
            confirmAction: () => {
              setShowDeleteModal(false);
              setShowAccountManagerUserModal(false);
              eventHandlers.deleteAccountManager();
            }
          }}
        />
      </div>
      {showAccountManagerUserModal && (
        <AccountManagerPersonModal
          config={{ showModal: showAccountManagerUserModal }}
          eventHandlers={{
            closeHandler: () => {
              setShowAccountManagerUserModal(false);
            },
            chooseUser: (unitTypeModel: UnitTypeUiModel) => {
              eventHandlers.addAccountManager(unitTypeModel);
              setShowAccountManagerUserModal(false);
            }
          }}
        />
      )}
    </>
  );
};
